export default [
    {
        name: 'order',
        path: '/order',
        component: ( ) => import('@/views/order_form/OrderFormView.vue')
    }
]